import { Controller } from 'stimulus';
import { patch } from '@rails/request.js';

export default class extends Controller {
  static values = { url: String };

  async toggle(event) {
    if (!this.urlValue) {
      return;
    }

    const checkbox = event.target;
    const checked = checkbox.checked;

    try {
      const response = await patch(this.urlValue, {
        body: { dismiss: checked },
        responseKind: 'html',
      });

      if (!response.ok || response.redirected) {
        checkbox.checked = !checked;
      }
    } catch {
      checkbox.checked = !checked;
    }
  }
}
